// extracted by mini-css-extract-plugin
export var columnItem = "_a2-3";
export var columnItemDraggable = "_a2-4";
export var dragHandle = "_a2-0";
export var dragHandleHovered = "_a2-1";
export var dropdown = "_a2-5";
export var dropdownContent = "_a2-7";
export var dropdownInner = "_a2-6";
export var filterDropdownHeader = "_a2-8";
export var icon = "_a2-2";
export var sectionDivider = "_a2-9";